import isHttpProtocol from './isHttpProtocol';

/**
 * Returns `value` only if it is an absolute http(s) URL; otherwise ''. Use for
 * backend- or user-supplied URLs rendered as links, which would otherwise
 * accept "javascript:", "data:" and other schemes.
 * @param {*} value
 * @returns {string}
 */
export default function getSafeHttpUrl(value) {
  if (typeof value !== 'string') return '';

  const trimmed = value.trim();
  try {
    const { protocol } = new URL(trimmed);
    return isHttpProtocol(protocol) ? trimmed : '';
  } catch (_) {
    return '';
  }
}
